export const EMAIL_REGEX =
  // eslint-disable-next-line max-len
  /^[A-Za-z0-9_%+'+-][A-Za-z0-9_%+'+-]*(?:\.[A-Za-z0-9_%+'+-]+)*@[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?(?:\.[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*\.[A-Za-z]{2,}$/;
